import { lazy, Suspense } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import './App.css';
import { RouteProvider } from './RouteContext';
import LandingPage from './LandingPage';

// Lazy load pipeline components
const BathtubGeneratorPage = lazy(() => import('./pipelines/bathtub').then(module => ({ default: module.GeneratorPage })));
const BathtubCurtainGeneratorPage = lazy(() => import('./pipelines/bathtub-curtain').then(module => ({ default: module.GeneratorPage })));
const PortraitMugGeneratorPage = lazy(() => import('./pipelines/portrait-mug').then(module => ({ default: module.GeneratorPage })));
const AnimatedMugGeneratorPage = lazy(() => import('./pipelines/animated-mug').then(module => ({ default: module.GeneratorPage })));
const ChristmasHandtowelGeneratorPage = lazy(() => import('./pipelines/christmas-handtowel').then(module => ({ default: module.GeneratorPage })));
const OrdersPage = lazy(() => import('./orders/OrdersPage'));
const CheckoutPage = lazy(() => import('./orders/CheckoutPage'));
const ThankYouPage = lazy(() => import('./orders/ThankYouPage'));

function App() {
  // Get default route from environment variable (set at build time)
  const defaultRoute = process.env.REACT_APP_DEFAULT_ROUTE as string;

  return (
    <RouteProvider defaultRoute={defaultRoute}>
      <Router>
        <Suspense fallback={
          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh' }}>
            <div>Loading...</div>
          </div>
        }>
          <Routes>
            {/* Root redirects to christmas-handtowel */}
            <Route path="/" element={<Navigate to="/christmas-handtowel/" replace />} />

            {/* Landing page showing all pipelines */}
            <Route path="/all" element={<LandingPage />} />

            {/* Order routes */}
            <Route path="/orders" element={<OrdersPage />} />
            <Route path="/orders/thank-you" element={<ThankYouPage />} />
            <Route path="/:pipeline/results/:uuid/runs/:runUuid/checkout" element={<CheckoutPage />} />

            {/* Routes for bathtub pipeline */}
            <Route path="/bathtub/" element={<BathtubGeneratorPage />} />
            <Route path="/bathtub/creator" element={<BathtubGeneratorPage />} />
            <Route path="/bathtub/results" element={<BathtubGeneratorPage />} />
            <Route path="/bathtub/results/:uuid" element={<BathtubGeneratorPage />} />

            {/* Routes for bathtub-curtain pipeline */}
            <Route path="/bathtub-curtain/" element={<BathtubCurtainGeneratorPage />} />
            <Route path="/bathtub-curtain/creator" element={<BathtubCurtainGeneratorPage />} />
            <Route path="/bathtub-curtain/results" element={<BathtubCurtainGeneratorPage />} />
            <Route path="/bathtub-curtain/results/:uuid" element={<BathtubCurtainGeneratorPage />} />

            {/* Routes for portrait-mug pipeline */}
            <Route path="/portrait-mug/" element={<PortraitMugGeneratorPage />} />
            <Route path="/portrait-mug/creator" element={<PortraitMugGeneratorPage />} />
            <Route path="/portrait-mug/results" element={<PortraitMugGeneratorPage />} />
            <Route path="/portrait-mug/results/:uuid" element={<PortraitMugGeneratorPage />} />

            {/* Routes for animated-mug pipeline */}
            <Route path="/animated-mug/" element={<AnimatedMugGeneratorPage />} />
            <Route path="/animated-mug/creator" element={<AnimatedMugGeneratorPage />} />
            <Route path="/animated-mug/results" element={<AnimatedMugGeneratorPage />} />
            <Route path="/animated-mug/results/:uuid" element={<AnimatedMugGeneratorPage />} />

            {/* Routes for christmas-handtowel pipeline */}
            <Route path="/christmas-handtowel/" element={<ChristmasHandtowelGeneratorPage />} />
            <Route path="/christmas-handtowel/creator" element={<ChristmasHandtowelGeneratorPage />} />
            <Route path="/christmas-handtowel/results" element={<ChristmasHandtowelGeneratorPage />} />
            <Route path="/christmas-handtowel/results/:uuid" element={<ChristmasHandtowelGeneratorPage />} />
          </Routes>
        </Suspense>
      </Router>
    </RouteProvider>
  );
}

export default App;
